import profile from './profile/index.vue';

export default [
  {
    name: '账号信息',
    path: '/account/profile',
    component: profile,
  },
];
